import { Box, Button, Card, Flex, Heading, Text } from "@radix-ui/themes";
import { useEffect, useState } from "react";
import { useUpdatePickedWinnerUserData } from "./hooks/useUpdateWInnerUserData";
export const PickerWinnerPopupUI = ({ data }: { data: any }) => {
  const [seeAllMembersModalOpen, setSeeAllMembersModalOpen] =
    useState<boolean>(true);

  useEffect(() => {
    setSeeAllMembersModalOpen(true);
  }, [data]);

  const { updateWinner } = useUpdatePickedWinnerUserData();

  if (!seeAllMembersModalOpen) {
    return;
  }

  return (
    <Flex
      align="center"
      justify="center"
      direction="column"
      className="picked-winner"
    >
      <Card>
        <Heading align="center">{data?.winReason}</Heading>
        <Flex align="center" justify="center">
          <Text size="4" align="center">
            Go to a lego representative to collect a LEGO KIT prize
          </Text>
        </Flex>

        <Box mt="4">
          <Flex gap="4" direction="column">
            <Button
              variant="solid"
              size="3"
              onClick={async () =>
                await updateWinner({
                  winnerUid: data.winnerUid,
                  challengeId: data.challengeSlug,
                }).then(() => {
                  setSeeAllMembersModalOpen(false);
                })
              }
            >
              I have collected my prize
            </Button>

            <Button
              color="gray"
              variant="soft"
              size="3"
              onClick={() => setSeeAllMembersModalOpen(false)}
            >
              Remind me again later
            </Button>
          </Flex>
        </Box>
      </Card>
    </Flex>
  );
};
